<template>
    <div class="file-table-container">
        <el-table :data="tableData" header-cell-class-name="header-cell-style" header-row-class-name="header-row-style"
            cell-class-name="cell-style" row-class-name="row-style" stripe height="100%" style="width: 100%">
            <el-table-column type="index" label="序号" width="100"></el-table-column>
            <el-table-column prop="name" min-width="200" label="文件名称"></el-table-column>
            <el-table-column prop="type" label="格式"></el-table-column>
            <!-- <el-table-column prop="update" label="更新时间"></el-table-column> -->
            <el-table-column prop="time" label="上传时间"></el-table-column>
            <el-table-column prop="operation" label="操作">
                <template slot-scope="scope">
                    <el-button @click="read(scope.row)" type="text" size="small">查看</el-button>
                    <el-button @click="download(scope.row)" type="text" size="small">下载</el-button>
                    <el-button @click="remove(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>

            <template v-slot:empty>
                <img :src="require('../../../assets/img/not_found_data.png')">
            </template>
        </el-table>
    </div>
</template>

<script>
    import {
        DeleteF,
        DownloadFile,
    } from '@/api/equipment';
    export default {
        props: {
            data: Array
        },
        computed: {
            projectId: function () {
                return this.$store.getters.projectId;
            },
            tableData: function () {
                return this.data.reverse()
            }
        },
        methods: {
            read: function (file) {
                // console.log(file);
                this.$emit('openFile', file);
            },
            download: function (file) {
                var a = document.createElement('a')
                a.setAttribute('href', file.path+'?download=1')
                a.setAttribute('download', file.name)
                document.body.appendChild(a)
                a.style.display = 'none'
                a.click()
                document.body.removeChild(a)
            },
            // download: function (file) {
            //     let folderName = file.path.split('/')[file.path.split('/').length - 2]
            //     DownloadFile(this.projectId, folderName, file.name).then(res => {
            //         if (res.status == 200) {
            //             this.downLoadXls(res.data, file.name)
            //             this.$message({
            //                 type: 'success',
            //                 message: '下载成功'
            //             });
            //         } else {
            //             this.$message({
            //                 type: 'error',
            //                 message: '下载失败'
            //             });
            //         }
            //     });
            // },
            remove(file) {
                this.$confirm(`从列表中删除“${file.name}”。`, '确认删除文件吗?', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let arr = file.path.split('/')
                    let folderName = arr[arr.length - 2]
                    DeleteF(this.projectId, '/' + folderName + '/' + file.name + '.' + file.type).then(res => {
                        if (res.data.code == 200) {
                            this.$parent.getAll(folderName).then(() => {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功'
                                });
                            })
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.errMsg
                            });
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消删除'
                    });
                });
            },
            // downLoadXls(data, filename) {
            //     // var blob = new Blob([data], { type: "application/zip" }) // 接收的是blob，若接收的是文件流，需要转化一下
            //     if (typeof window.chrome !== 'undefined') {
            //         var link = document.createElement('a');
            //         // link.href = window.URL.createObjectURL(data);
            //         link.href = window.URL.createObjectURL(new Blob([data], {
            //             type: "application/force-download"
            //         }))
            //         link.download = filename;
            //         link.click();
            //     } else if (typeof window.navigator.msSaveBlob !== 'undefined') {
            //         var blob = new Blob([data], {
            //             type: 'application/force-download'
            //         });
            //         window.navigator.msSaveBlob(blob, filename);
            //     } else {
            //         var file = new File([data], filename, {
            //             type: 'application/force-download'
            //         });
            //         window.open(URL.createObjectURL(file));
            //     }
            // }
        }
    }
</script>

<style lang="less" scoped>
    .file-table-container {
        height: 100%;
    }
</style>